// @ts-strict-ignore
import {Component} from "@angular/core";
import {AbstractFlatWidget} from "src/app/shared/components/flat/abstract-flat-widget";
import {Modal} from "src/app/shared/components/flat/flat";
import {ChannelAddress, CurrentData, Utils} from "src/app/shared/shared";

import {ModalComponent} from "../modal/modal";


@Component({
  selector: "Controller_Limit_Sell_To_Grid_PV_Inverter_Group",
  templateUrl: "./flat.html",
  standalone: false,
})
export class FlatComponent extends AbstractFlatWidget {

  public mode: string;
  public tariffState: string;

  public CONVERT_TO_MODE = Utils.CONVERT_PV_MODE(this.translate);
  public readonly CONVERT_TARIFF_STATE = Utils.CONVERT_PV_MODE_FOR_TARIFF(this.translate);

  protected modalComponent: Modal | null = null;

  protected override afterIsInitialized(): void {
    this.modalComponent = this.getModalComponent();
  }

  protected getModalComponent(): Modal {
    return {
      component: ModalComponent,
      componentProps: {
        component: this.component,
      },
    };
  };

  protected override getChannelAddresses(): ChannelAddress[] {
    return [
      new ChannelAddress(this.component.id, "Mode"),
      new ChannelAddress(this.component.id, "TariffState"),
    ];
  }

  protected override onCurrentData(currentData: CurrentData) {
    this.mode = currentData.allComponents[this.component.id + "/Mode"];
    this.tariffState = currentData.allComponents[this.component.id + "/TariffState"];
  }

}
